<template>  <svg
    class="icon icon-hamburger item__mobile__open"
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="2"
      rx="1"
      fill="#333333"
    />
    <rect
      y="6"
      width="20"
      height="2"
      rx="1"
      fill="#333333"
    />
    <rect
      y="12"
      width="20"
      height="2"
      rx="1"
      fill="#333333"
    />
  </svg></template>